module.exports = __webpack_public_path__ + "4c574e25f3db01273c5312c33126f1c1.png";